
import axiosRequest from "@/api/axios-optimize"

// 获取付款记录列表
export function getList(data = {}, config = {
  noShowLoading: true, // 不展示全局加载动画
  preventDuplicateRequestsType: "prevent"
}) {
  return axiosRequest.get(`/xiaobuAdmin/finance/payRecord/getList`, { params: data, ...config})
}

// 新增
export function createItem(data = {}, config = {
  preventDuplicateRequestsType: "prevent"
}) {
  return axiosRequest.post(`/xiaobuAdmin/finance/payRecord/create`, data, config)
}